<h1>Health check endpoint</h1>
